import React, { forwardRef } from 'react';
import classNames from 'classnames';
import './Dropdown.scss';

interface DropdownProps {
  children: React.ReactNode;
  className?: string;
}

export const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(
  ({ children, className }, ref) => {
    return (
      <div ref={ref} className={classNames('c-dropdown', className)}>
        {children}
      </div>
    );
  }
);
